import { z } from "zod";

import { zOutSchema } from "./common";

const zOut = z.array(zOutSchema);
type Out = z.infer<typeof zOut>;

export { zOut };
export type { Out };
